import { ContentfulEntryType } from "./contentful-entry.type";
import { ContentfulAssetType } from "./contentful-asset.type";

export class DashboardType extends ContentfulEntryType {
  public get title(): string {
    return this.fields["title"];
  }

  public get progressHeadline(): string {
    return this.fields["progressHeadline"];
  }

  public get nextLessonSubheadline(): string {
    return this.fields["nextLessonSubheadline"];
  }

  public get previousLessonSubheadline(): string {
    return this.fields["previousLessonSubheadline"];
  }

  public get getStartedButtonText(): string {
    return this.fields["getStartedButtonText"];
  }

  public get playAgainButtonText(): string {
    return this.fields["playAgainButtonText"];
  }

  public get lessonGoalsSubheadline(): string {
    return this.fields["lessonGoalsSubheadline"];
  }

  public get welcomeHeadline(): string {
    return this.fields["welcomeHeadline"];
  }

  public get welcomeVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["welcomeVideo"]);
  }

  public get upgradeHeadline(): string {
    return this.fields["upgradeHeadline"];
  }

  public get upgradeContent(): string {
    return this.fields["upgradeContent"];
  }

  public get mindsetVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["mindsetVideo"]);
  }

  public get englishVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["englishVideo"]);
  }

  public get mathVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["mathVideo"]);
  }

  public get readingVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["readingVideo"]);
  }

  public get scienceVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["scienceVideo"]);
  }

  public get gcseEnglishVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["gcseEnglishVideo"]);
  }

  public get gcseMathsVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["gcseMathsVideo"]);
  }

  public get gcseScienceVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["gcseScienceVideo"]);
  }

  public get satEnglishVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["satEnglishVideo"]);
  }

  public get satMathVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["satMathVideo"]);
  }

  public get satReadingVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["satReadingVideo"]);
  }

  public get satWritingVideo(): ContentfulAssetType {
    return new ContentfulAssetType(this.fields["satWritingVideo"]);
  }
}
